import { KeyboardEvent, useEffect, useRef } from 'react';
import { IoSendSharp } from 'react-icons/io5';
import { Textarea } from '@nextui-org/react';
import { ImSpinner2 } from 'react-icons/im';
import { useChat } from '@/contexts/chat-context';

export const ChatForm = () => {
  const inputRef = useRef<HTMLTextAreaElement>(null);
  const { isStreaming, message, setMessage, onSendMessage } = useChat();

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSendMessage();
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  return (
    <div data-testid="chat-form" className="p-4 bg-gradient-to-b from-[#FFFFFF] to-[#D1D1D1]">
      <div className="py-2 px-3 border-1 border-[#D1D1D1] rounded-xl bg-white flex items-center gap-4">
        <Textarea
          ref={inputRef}
          value={message}
          onChange={e => setMessage(e.target.value)}
          placeholder="Write a message"
          disabled={isStreaming}
          minRows={1}
          maxRows={4}
          classNames={{
            input: 'resize-none !outline-none',
            inputWrapper: '!bg-white border-0 shadow-none px-0'
          }}
          onKeyDown={handleKeyDown}
        />
        <button
          onClick={() => onSendMessage()}
          disabled={isStreaming || !message.trim()}
          className="flex-none flex items-center justify-center w-10 h-10 rounded-full disabled:opacity-50 disabled:cursor-not-allowed text-jacarta-500"
        >
          {isStreaming ? <ImSpinner2 className="animate-spin" size={24} /> : <IoSendSharp size={24} />}
        </button>
      </div>
    </div>
  );
};
